import React from 'react';
import './index.css';

const Loading = () => {
    return (
        <div className="dots-container">
            <div className="dot dot1"></div>
            <div className="dot dot2"></div>
            <div className="dot dot3"></div>
        </div>
    )
}

export default Loading;